import CmsService from 'services/CMS';
import { version } from 'config';
import StorageService from 'services/StorageService';

const _compareVersion = (version1, version2) => {
    const arrayVersion1 = version1.split('.');
    const arrayVersion2 = version2.split('.');

    let isHigher = false;

    if (!(arrayVersion1.length === 3 && arrayVersion2.length === 3)) return isHigher;

    for (let i = 0; i < 3; i++) {
        if (parseInt(arrayVersion1[i]) > parseInt(arrayVersion2[i])) {
            isHigher = true;
            break;
        } else if (parseInt(arrayVersion1[i]) < parseInt(arrayVersion2[i])) {
            break;
        }
    }

    return isHigher;
}

const verify = () => {

    CmsService.getVersion().then(data => {
        let apiVersion = data.acf.content[0].version;
        const jsVersion = version;
        const localVersion = StorageService.getItem('version');

        if (typeof window !== 'undefined' && _compareVersion(apiVersion, jsVersion) && localVersion !== apiVersion) {
            localStorage.setItem('version', apiVersion);
            window.location.reload(true);
        }
    });
}

const VersionService = {
    verify
}

export default VersionService;
